// This is a temporary version

import { useState, useEffect, useRef } from 'react';

import { ViewEnum } from '@/types';
import { useAppearanceStore } from '@/store/appearance';
import { tooltip } from 'styled-system/recipes';

type Position = 'avatar' | 'appbar';

export const AccountTooltip = ({ 
	position 
}: {
	position: Position;
}) => {
	const [isShow, setIsShow] = useState(false);
	const [text, setText] = useState('');
	const view = useAppearanceStore(state => state.view);
	const timerRef = useRef<ReturnType<typeof setTimeout>>();

	useEffect(() => {
		const showAccountTooltip = ((event: CustomEvent) => {
			setText(event.detail.text ?? '');
			setIsShow(true);
			clearTimeout(timerRef.current);
			timerRef.current = setTimeout(
				() => setIsShow(false), 
				3000
			);
		}) as EventListener;

		document.addEventListener('show-account-tooltip', showAccountTooltip);

		return () => {
			clearTimeout(timerRef.current);
			document.removeEventListener('show-account-tooltip', showAccountTooltip);
		};
	}, []);

	return isShow ? (
		{ 
			[ViewEnum.galaxy]: (
				<div 
					className="tip tip--promo tip--right" 
					data-open="true"
				>
					<div className="scrollbar scrollbar--tip">
						<div className="tip__content">{text}</div>
					</div>
				</div>
			),
			[ViewEnum.mars]: (
				<div
					className={tooltip({ 
						visual: 'basic', 
						...(position === 'appbar' ? { vertical: 'top' } : {}), 
						horizontal: 'right', 
						size: 'sm' 
					})}
					data-active="true"
				>
					{text}
				</div>
			)
		}[view]
	) : null;
};